const authRoutes = {
    login: "/login",
    logout: "/logout",
    codeSentToEmail: "/code-sent-to-email",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",
  };
  
  export default authRoutes;
  